module.exports = __webpack_public_path__ + "img/widget_width.e26dc77a.svg";